<template>
	<div id="postlive">
		<b-container class="py-md-5">
			<b-row align-v="center">
				<b-col 	cols="12"
						lg="auto"
						class="mw-lg-50">
					<div class="p-5 p-md-8 rounded" :class="[asset.background_color ? 'bg-'+asset.background_color : 'bg-light', asset.text_color ? 'text-'+asset.text_color : 'text-dark']">
						<h4 class="title-color" v-html="makeBr(asset.title)"></h4>
						<p class="lead m-0 pt-3" v-html="makeBr(asset.postlive)" v-if="asset.postlive"></p>
						<p class="lead m-0 pt-3" v-html="makeBr(asset.description)" v-else-if="asset.description"></p>
					</div>
				</b-col>
				<b-col 	cols="12"
						lg="auto"
						class="ml-auto mw-lg-50"
						v-if="postliveQa()">
					<Ask />
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
	import Ask from '@/components/asset/Ask.vue'
	export default {
		computed: {
			asset() {
				return this.$store.getters.asset
			}
		},
		components: {
			Ask
		},
		methods: {
			postliveQa() {
				if(this.asset.asset_qa && this.asset.asset_qa.enabled && this.asset.asset_qa.postlive) return true
				return false
			},
			makeBr(text) {
				return text.replace('\n', '<br>')
			}
		}
	}
</script>
